import each from 'lodash/each'
import clone from 'lodash/clone'
import URLParser from 'url-parse'
import QueryString from 'query-string'

import routes from '@/constants/routes.json'
import urls from '@/constants/urls.json'

import Platform from '@/plugin-platforms'

// Filter Query String params
// Remove null value and zero length arrays
export const filterQueryStringParams = (params) => {
  let newParams = {}

  for (let property in params) {
    let value = params[property]

    if (value !== null) {
      if (value instanceof Array) {
        if (value.length) {
          newParams[property] = value
        }
      } else {
        newParams[property] = value
      }
    }
  }

  return newParams
}

// Generate the Url
export const generateUrl = (url, params) => {
  let queryString = clone(params)

  // Replace the Parameters that are in the URL
  each(params, (val, key) => {
    let keyVar = '{' + key + '}'
    if (url.indexOf(keyVar) !== -1) {
      url = url.replace(keyVar, val)
      delete queryString[key]
    }
  })

  // Append the extra Params as Query String
  let newUrl = new URLParser(url)
  let query = {}
  each(queryString, (val, key) => {
    query[key] = val
  })

  // newUrl.set('hostname', process.env.apiHostname)
  newUrl.set('query', '')

  return newUrl.toString() + '?' + QueryString.stringify(query, { arrayFormat: 'bracket' })
}

// Create the full url from route name
// Example: route('authMemberSwitch', { uuid: 'tarun', 'includes': 'teams' })
export const route = (name, params = {}) => {
  let url = `${process.env.VUE_APP_API_BASE}${routes[name]}`
  return generateUrl(url, params)
}

// Create the full web url from route name
export const webUrl = (name, params = {}) => {
  let url = `${process.env.VUE_APP_ICONSCOUT_DOMAIN}${urls[name]}`
  // Add utm params
  const result = generateUrl(url, {
    ...params,
    utm_source: 'icondrop',
    utm_medium: Platform.platform,
    utm_campaign: process.env.VUE_APP_VERSION
  })

  return result
}
